import { NUMBER_FORMAT_LOCALE } from '@hex/shared/i18n';

type FormatNumberOptions = {
  fixedDecimal?: boolean;
};

export function formatNumber(
  value: number | bigint | null,
  options?: FormatNumberOptions,
): string {
  const intlOptions: Intl.NumberFormatOptions = {};

  if (value === undefined || value === null) {
    return '-';
  }

  if (options?.fixedDecimal) {
    intlOptions.minimumFractionDigits = 2;
    intlOptions.maximumFractionDigits = 2;
  }

  const formatter = new Intl.NumberFormat(NUMBER_FORMAT_LOCALE, intlOptions);

  return formatter.format(value);
}
